module.exports = __webpack_public_path__ + "static/media/cherry_plum_compote.689c82ca.png";